import { translate } from '../../utils/Common';
import Spinner from '../Spinner';
const ShowTable = ({ itemArray, headerRow, Item, selectItem, title, noItemsFound, actualPage, itemsShowing, size, visibleColumns, renderers, version }) => {
    return (
        <>
            { title && <p className='mx-0 mt-0 mb-2 p-0'>{title}</p> }
            <div className="modern-table-container">
                <table className={`modern-table table-${size ? size : 'sm'}`}>
                    {
                        (version===2 && visibleColumns.length > 0) ? (
                            <thead>
                            <tr>
                            {visibleColumns.map((col) => (
                                <th key={col.id}>{col.icon && <col.icon className="mr-1" size={16}/>}{col.name}</th>
                            ))}
                            </tr>   
                        </thead>
                        ):(
                        <thead>
                            { headerRow }
                        </thead>
                        )
                    }
                   
                   {
                    version===2 && visibleColumns.length > 0 ? (
                        <tbody>
                        {itemArray?.slice((actualPage - 1) * itemsShowing, actualPage * itemsShowing)
                          .map((item, index) => (
                            <Item
                              key={index}
                              item={item}
                              index={index}
                              selectItem={selectItem}
                              visibleColumns={visibleColumns}
                              renderers={renderers}
                            />
                        ))}
                      </tbody>
                    ):(
                        <tbody>
                        { itemArray ?
                            (itemArray?.length > 0 ?
                                itemArray.map((item, index) => 
                                (index >= ((actualPage * itemsShowing) - itemsShowing) &&
                                index < (actualPage * itemsShowing)) &&
                                    <Item key={index} index={index} item={item} selectItem={selectItem} 
                                    visibleColumns={visibleColumns} renderers={renderers}/>)
                                :
                                <tr className="no-results"><td colSpan={5}>{noItemsFound ? noItemsFound : translate("global.noResults")}</td></tr>
                            )
                            :
                            <tr className="loading"><td colSpan={5}><Spinner type={1} /></td></tr>
                        }
                        </tbody>
                    )
                   }
                   
                </table>
            </div>
        </>
    );
}

export default ShowTable;